
// import ResponsiveRow from '@/components/responsive-row';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'page-card',
  props: {
    title: {
      type: String,
      default: '',
    },
    required: Boolean,
  },
  setup() {

  },
  components: {
    // ResponsiveRow,
  },
});
